const TextureAssets: string[] = [
  'baked-game-boy.jpg',
  'baked-cartridge-tetris.jpg',
  'baked-cartridge-tetris-in-pocket.jpg',
  'baked-cartridge-zelda.jpg',
  'baked-cartridge-zelda-in-pocket.jpg',
  'baked-cartridge-space-invaders.jpg',
  'baked-cartridge-space-invaders-in-pocket.jpg',
  'baked-power-indicator.jpg',
  'baked-screen-shadow.png',
  'baked-cartridge-pocket.jpg',
  'baked-cartridge-pocket-with-cartridge.jpg',

  'background.jpg',
];

const ModelAssets: string[] = [
  'game-boy.glb',
  'game-boy-cartridge.glb',
];

const PixiAssets: string[] = [
  'assets/other/overlay.png',
  'assets/other/sound-icon.png',
  'assets/other/sound-icon-mute.png',

  'assets/other/nintendo-logo-screen.png',
  'assets/other/stop-sign.png',

  'assets/spritesheets/tetris-sheet.json',
  'fonts/tetris.ttf',

  'assets/spritesheets/space-invaders-sheet.json',
  'fonts/dogicapixel.ttf',
];

const AudioAssets: string[] = [
  'power-switch.mp3',
  'insert-cartridge.mp3',
  'eject-cartridge.mp3',
  'game-boy-load.mp3',
  'zelda-intro-sound.mp3',

  // tetris
  'tetris-music.mp3',
  'move-side.mp3',
  'rotate-shape.mp3',
  'shape-fall.mp3',
  'line-clear.mp3',
  'tetris-pause.mp3',
  'tetris-game-over.mp3',
  'tetris-game-over-final.mp3',

  // space invaders
  'player-shoot.mp3',
  'enemy-killed.mp3',
  'player-killed.mp3',
];

export {
  TextureAssets,
  ModelAssets,
  PixiAssets,
  AudioAssets,
};